import { Button } from '@utilitywarehouse/hearth-react';
import { WarningMediumIcon } from '@utilitywarehouse/hearth-react-icons';
import { color } from '@utilitywarehouse/hearth-tokens/js';
import { useNavigate } from 'react-router-dom';

import {
  Dialog,
  DialogActions,
  DialogID,
  DialogProps,
  useDialog,
} from '@components/Dialog';
import { paths } from '@constants/paths';

import './styles.scss';

interface StartAgainDialogProps extends DialogProps {
  onExit: () => Promise<void>;
}

const StartAgainDialog = ({ onExit }: StartAgainDialogProps) => {
  const dialog = useDialog(DialogID.START_AGAIN);
  const navigate = useNavigate();

  const handleCancel = () => dialog.setOpen(false);

  const handleExit = async () => {
    await onExit();
    navigate(paths.root);
  };

  return (
    <Dialog
      id={dialog.id}
      onClose={handleCancel}
      heading="Are you sure you want to exit?"
      image={<WarningMediumIcon color={color.red[700]} />}
      description="If you leave now, you’ll lose your progress."
    >
      <DialogActions className="startAgainDialog__actions">
        <Button type="button" variant="outline" onClick={handleCancel}>
          Cancel
        </Button>
        <Button
          type="button"
          variant="solid"
          colorScheme="destructive"
          onClick={handleExit}
        >
          Exit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export { StartAgainDialog };
